import { IconButton } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React, { useCallback } from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import Logout from "@mui/icons-material/Logout";
import MenuItem from "@mui/material/MenuItem";
import { deepOrange } from "@mui/material/colors";
import { useTheme } from "next-themes";

import { useTranslation } from "@/lib/i18n";
import {
  useAuthStoreActions,
  useCognitoSignOutUrlQuery,
  useUserInfoQuery,
} from "@/features/shared/features/authentication";
import Icon from "@/components/icon/icon";

import * as styles from "./user-menu.styles";

const ORIGIN = String(new URL(document.location.origin));

export default function UserMenu() {
  const { t } = useTranslation();
  const { clearAuthToken } = useAuthStoreActions();
  const signOutUrlQuery = useCognitoSignOutUrlQuery(ORIGIN);
  const userInfoQuery = useUserInfoQuery();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSignOut = () => {
    clearAuthToken();

    window.location.replace(String(signOutUrlQuery.data));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const firstLetter = userInfoQuery.data?.email?.charAt(0) ?? "K";

  const open = Boolean(anchorEl);

  const { resolvedTheme, setTheme } = useTheme();
  const toggleTheme = useCallback(() => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  }, [setTheme]);

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label="delete"
      >
        <Avatar sx={{ bgcolor: deepOrange[500], textTransform: "uppercase" }}>
          {firstLetter}
        </Avatar>
      </IconButton>

      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          ...styles.menu,
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={toggleTheme}>
          <ListItemIcon>
            <Icon name={resolvedTheme === "dark" ? "toggle-right" : "toggle-left"} />
          </ListItemIcon>
          {t("menu.darkmode")}
        </MenuItem>
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t("menu.account.logout")}
        </MenuItem>
      </Menu>
    </>
  );
}
